module.exports = __webpack_public_path__ + "static/L2_ux_2_2_eg-f3e2ced7e7c2b3bc79528d0ddebcd19e.png";